<template>
  <div class="refund-detail">
    <fixed-header title="售后详情"></fixed-header>
    <div class="refund-detail__main scroll-touch">
      <div class="refund-detail__top">
        <section class="refund-detail__status">
          <p>{{ getRefundStatusTitle(refundInfo.status, refundInfo.type) }}</p>
        </section>
        <section class="refund-detail__opt">
          <p>进度：</p>
          <p>亲爱的客户，{{ showProgressTitle }}</p>
          <p>
            <span v-if="isSellerSend" @click="confirmReceive">确认收货</span>
            <span v-if="showModify" @click="modifyAplly">修改申请</span>
            <span v-if="showCancel" @click="cancelRefund">取消申请</span>
            <span v-if="showAddress" @click="gotoAddExpress">填写物流</span>
            <span v-if="isConfirmAddr" @click="gotoAddExpress">确定地址</span>
          </p>
        </section>
      </div>
      <div v-if="showAddress" class="refund-detail__express">
        <span>寄回地址</span>
        <span>{{ backAddress.address }}</span>
      </div>
      <div v-if="showAddress" class="refund-detail__express">
        <span>商家电话</span>
        <span>{{ backAddress.mobile }}</span>
      </div>
      <div v-if="showAddress" class="refund-detail__express">
        <span>联系人</span>
        <span>{{ backAddress.consignee }}</span>
      </div>
      <div v-if="showAddress" class="refund-detail__express">
        <span>审核留言</span>
        <span>{{ refundInfo.remark }}</span>
      </div>
      <div v-if="showSellerRelivery" class="refund-detail__express">
        <span>物流公司</span>
        <span>{{ refundInfo.seller_delivery.express_name }}</span>
      </div>
      <div v-if="showSellerRelivery" class="refund-detail__express">
        <span>物流单号</span>
        <span>{{ refundInfo.seller_delivery.express_sn }}</span>
      </div>
      <div class="refund-detail__desc">
        <section>{{ refundTitle }}信息</section>
        <section>
          <img :src="goodsInfo.originalImg" alt=""/>
          <div>
            <p>{{ goodsInfo.goodsName }}</p>
            <p>{{ goodsInfo.specKeyName }}</p>
          </div>
        </section>
        <section>
          <p>{{ refundTitle }}原因：{{ refundInfo.reason }}</p>
          <p v-if="isRefund && refundInfo.refundMoney !== 0 && showMoney">退款金额：￥{{ refundInfo.refundMoney }}</p>
          <p v-if="isRefund && refundInfo.refundIntegral > 0">退还{{coinName}}：{{ refundInfo.refundIntegral }}</p>
          <p>
            申请时间：{{
              dateFormater(refundInfo.addtime * 1000, "yyyy-MM-dd hh:mm")
            }}
          </p>
          <p>{{ refundTitle }}说明：{{ refundInfo.describe }}</p>
          <p>凭证：</p>
          <div class="refund-detail__certificate">
            <div
                v-for="(img, index) in refundInfo.imgs"
                :key="index"
                class="refund-detail__img"
            >
              <img :src="img" alt="" @click="preView(img)"/>
            </div>
          </div>
        </section>
        <div v-if="refundInfo.remark && !showAddress" class="refund-detail__remark">
          审核留言：{{ refundInfo.remark }}
        </div>
      </div>
    </div>
    <div
        v-if="showPreView"
        class="refund-detail__preview"
        @click="closePreView"
    >
      <img :src="preViewimg"/>
    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import * as orderApi from 'apis/order';
import passedPng from 'assets/img/refund_status1.png';
import inReviewPng from 'assets/img/refund_status2.png';
import notPassPng from 'assets/img/refund_status3.png';
import { getRefundStatusTitle } from 'utils/refund';
import InputItem from 'components/common/InputItem';
import {
  APPLY_RETURN_GOODS,
  REFUND_CANCEL,
  REFUND_CHECK_PASS,
  REFUND_REJECT,
  REFUND_SELLER_RECEIVE,
  REFUND_SELLER_SEND,
  REFUND_SUCCESS,
  REFUND_USER_SEND,
  REFUND_WAIT_CHECK,
} from 'constants/refund';
import { hideMessageBox } from 'utils';
import { dateFormater } from 'utils/date';

export default {
  components: { FixedHeader, InputItem },
  data() {
    const { id } = this.$route.query;
    return {
      passedPng,
      inReviewPng,
      notPassPng,
      form: {
        id,
        express_name: '',
        express_sn: '',
      },
      id,
      goodsInfo: {},
      backAddress: {},
      refundInfo: { status: 0 },
      process: [],
      showPreView: false,
      preViewimg: {},
    };
  },
  computed: {
    showModify() {
      const {
        refundInfo: { status, storeId },
      } = this;
      return status === REFUND_WAIT_CHECK && storeId !== 97; /* 待审核 */
    },
    showMoney() {
      const {
        refundInfo: { storeId },
      } = this;
      return storeId !== 97; /* 待审核 */
    },
    showCancel() {
      const {
        refundInfo: { status },
        goodsInfo: { goodsFrom },
      } = this;
      if (goodsFrom === "happygo") {
        return false;
      }
      return (
        (status === REFUND_WAIT_CHECK || status === REFUND_CHECK_PASS)
      ); /* 待审核、审核通过 */
    },
    isRefundSuccess() {
      const {
        refundInfo: { status },
      } = this;
      return status === REFUND_SUCCESS; /* 退款、换货成功 */
    },
    isSellerSend() {
      const {
        refundInfo: { status },
      } = this;
      return status === REFUND_SELLER_SEND; /* 卖家已发货 */
    },
    isRefund() {
      const {
        refundInfo: { type },
      } = this;
      return type === APPLY_RETURN_GOODS;
    },
    refundTitle() {
      const {
        isRefund,
        refundInfo: { type },
      } = this;
      return isRefund || !type ? '退款' : '换货';
    },
    showAddress() {
      const {
        refundInfo: { status, isReturn },
      } = this;
      return status === REFUND_CHECK_PASS && isReturn === 1;
    },
    isConfirmAddr() {
      const {
        refundInfo: { status, isReturn },
      } = this;
      return status === REFUND_CHECK_PASS && isReturn === 2;
    },
    showSellerRelivery() {
      const {
        refundInfo: { status, seller_delivery },
      } = this;
      return seller_delivery ? status >= REFUND_SELLER_SEND : false;
    },
    showProgressTitle() {
      const {
        refundInfo: { status, isReturn },
      } = this;
      switch (status) {
        case REFUND_REJECT:
          return '您提交的审核未通过，如有疑问可联系在线客服。';
        case REFUND_CANCEL:
          return '您的申请已取消';
        case REFUND_WAIT_CHECK:
          return '您的申请已经成功提交，请等待客服处理';
        case REFUND_CHECK_PASS:
          if (isReturn === 2) {
            return '您的申请已经通过审核，无需要寄回商品';
          }
          return '您的申请已经通过审核，请填写物流信息';
        case REFUND_USER_SEND:
          return '您的快递已寄出，等待卖家收货'; /* 买家已发货 */
        case REFUND_SELLER_RECEIVE:
          return '已收到您的快递，正在处理您的申请';
        case REFUND_SELLER_SEND:
          return '您的快递已寄出，等待您确认收货'; /* 卖家已发货 */
        case REFUND_SUCCESS:
          return '您的申请已经完成，感谢您的支持';
        default:
          return '';
      }
    },
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    dateFormater,
    getRefundStatusTitle,
    preView(img) {
      if (!img) {
        return;
      }
      this.showPreView = true;
      this.preViewimg = img;
    },
    closePreView() {
      this.showPreView = false;
    },
    showImgByStatus(item) {
      const { status, img } = item;
      const { status: nowStatus } = this.refundInfo;
      if (img) {
        /* 如果已经给定了默认的图 就直接展示 */
        return img;
      }
      if (status <= nowStatus) {
        return this.passedPng;
      }
      return this.notPassPng;
    },
    gotoAddExpress() {
      this.$router.push({
        path: '/refund/express',
        query: {
          id: this.id,
          refundType: this.refundInfo.type,
          isReturn: this.refundInfo.isReturn,
          goodsFrom: this.goodsInfo.goodsFrom,
        },
      });
    },
    async fetchDetail() {
      const { id } = this;
      try {
        const {
          goodsInfo,
          refundInfo,
          refundInfo: { imgs },
          backAddress,
        } = await orderApi.getRefundDetail({ id });
        if (imgs && String(imgs).length > 0) {
          refundInfo.imgs = imgs.split(',');
        }
        this.goodsInfo = goodsInfo;
        this.refundInfo = refundInfo;
        this.backAddress = backAddress;
        this.getProcess();
      } catch (error) {
        this.$toast(`获取详情失败:${error.message}`);
      }
    },
    getProcess() {
      const {
        getRefundStatusTitle,
        setStatus,
        setStatus2,
        refundTitle,
        refundInfo: { type /* 售后类型 */, status: nowStatus /* 当前状态 */},
      } = this;
      if (nowStatus === REFUND_REJECT) {
        /* 审核拒绝 */
        this.process = [
          { img: passedPng, title: '提交申请' },
          { slot: 1 },
          { img: passedPng, title: '审核拒绝' },
        ];
      } else if (nowStatus === REFUND_CANCEL) {
        /* 取消 */
        this.process = [
          { img: passedPng, title: '提交申请' },
          { slot: 1 },
          { img: passedPng, title: `取消${refundTitle}` },
        ];
      } else {
        this.process = [
          {
            img: passedPng,
            title: '提交申请',
          },
          {
            slot: 1,
          },
          {
            title: getRefundStatusTitle(setStatus(nowStatus)),
            status: setStatus(nowStatus),
          },
          {
            slot: 1,
          },
          {
            title: '用户已发货',
            status: REFUND_USER_SEND,
          },
          {
            slot: 1,
          },
          {
            title: '卖家已收货',
            status: REFUND_SELLER_RECEIVE,
          },
          {
            slot: 1,
          },
          {
            title: getRefundStatusTitle(setStatus2(type)),
            status: setStatus2(type),
          },
          {
            slot: 1,
          },
          {
            title: `${refundTitle}成功`,
            status: REFUND_SUCCESS,
          },
        ];
      }
    },
    setStatus(nowStatus) {
      if (nowStatus < REFUND_USER_SEND) {
        return nowStatus; /* 返回审核通过或者待审核 */
      }
      return REFUND_CHECK_PASS; /* 返回审核通过 */
    },
    setStatus2(type) {
      if (type === APPLY_RETURN_GOODS) {
        return REFUND_SELLER_RECEIVE; /* 卖家已收货 */
      }
      return REFUND_SELLER_SEND; /* 卖家已发货 */
    },
    cancelRefund() {
      const { id } = this.refundInfo;
      this.$message
        .confirm('确认需要取消申请售后?')
        .then(async () => {
          try {
            await orderApi.cancelRefund({ id });
            this.fetchDetail();
          } catch (error) {
            this.$toast({ message: `提交失败:${error.message}`, duration: 3000 });
          }
        });
    },
    modifyAplly() {
      const { id } = this.refundInfo;
      this.$router.push({
        path: '/refund/apply',
        query: { id },
      });
    },
    async confirmReceive() {
      this.$message.confirm('确认收货?').then(async () => {
        await orderApi.confirmReceive({ id: this.id });
        this.fetchDetail();
      });
    },
  },
  beforeDestroy() {
    hideMessageBox();
  },
};
</script>

<style lang="scss">
.refund-detail {
  height: 100%;
  box-sizing: border-box;

  &__preview {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background: #000000;

    img {
      padding-top: 50%;
    }
  }

  &__main {
    height: 100%;
    font-size: 28px;
  }

  &__top {
    margin-bottom: 20px;
    background: #fff;
  }

  &__status {
    background-image: linear-gradient(90deg, #fa841b 3%, #ff6002 96%);
    // height: 215px;
    padding: 40px 30px;
    font-size: 30px;
    color: #fff;
    font-weight: 600;
    /* display: flex;
      align-items: center;
      justify-content: space-around; */
    /* &-line{
        flex:1;
        height: 3px;
        max-width: 80px;
        background: #fff;
        margin-bottom: 40px;
      }
      &-item {
        min-width: 60px;
        text-align: center;
        div:first-child {
          img {
            width: 60px;
            height: 60px;
          }
          margin-bottom: 13px;
        }
      } */
  }

  &__opt {
    padding: 30px;
    font-size: 26px;
    color: #000000;

    p {
      margin-bottom: 10px;
    }

    p:nth-child(3) {
      margin: 20px 0 0 0;
      display: flex;
      justify-content: flex-end;

      span {
        padding: 10px 26px;
        border: 2px solid #ff4c00;
        border-radius: 8px;
        color: #ff4c00;
        text-align: center;
        font-weight: 600;
        margin-left: 10px;
      }
    }
  }

  &__common {
    display: flex;
    padding: 15px 30px;
    align-items: center;

    span {
      margin-right: 20px;
    }

    &-input {
      flex: 1;
      height: 40px;
      font-size: 28px;
    }
  }

  &__express {
    @extend .refund-detail__common;
    background: #fff;
    margin: 20px 0;

    span:first-child {
      width: 120px;
      margin-right: 10px;
    }

    span:last-child {
      flex: 1;
    }
  }

  &__desc {
    background: #fff;

    section:nth-child(1) {
      padding: 0 30px;
      height: 80px;
      line-height: 80px;
      font-size: 26px;
    }

    section:nth-child(2) {
      padding: 30px;
      background: #f2f2f2;
      font-size: 26px;
      display: flex;

      img {
        width: 150px;
        height: 150px;
        margin-right: 30px;
      }

      div {
        flex: 1;

        p {
          margin-top: 12px;
        }

        p:last-child {
          color: #4a4a4a;
        }
      }
    }

    section:nth-child(3) {
      padding: 30px;
      font-size: 24px;
      color: #9b9b9b;

      p {
        height: 50px;
        line-height: 50px;
      }
    }

    section:nth-child(4) {
      padding: 30px;
      font-size: 24px;
      color: #9b9b9b;

      p {
        height: 50px;
        line-height: 50px;
      }
    }
  }

  &__certificate {
    background: #ffffff;
    display: flex;
    flex-direction: row;
  }

  &__img {
    width: 148px;
    height: 148px;
    margin-right: 23px;
    border-radius: 10px;

    img {
      height: 100%;
      max-width: 100%;
      border-radius: 10px;
    }
  }

  &__remark {
    margin: 20px;
    height: 60px;
    line-height: 60px;
  }
}
</style>
